import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import {
  CarePlanTemplateStatus,
  ICarePlanTemplate,
  ICarePlanTemplateInput,
} from '../../entities/CarePlanTemplate/CarePlanTemplate.ts';

export class CarePlanTemplatesApi extends BaseApi {
  private static baseApiUrl: string = `${BaseApi.apiUrl}/CarePlanTemplates`;

  public static apiUrls = {
    getByFacility: `${CarePlanTemplatesApi.baseApiUrl}`,
    getForInvitation: `${CarePlanTemplatesApi.baseApiUrl}/ForInvitation`,
    getById: `${CarePlanTemplatesApi.baseApiUrl}/:id`,
    post: `${CarePlanTemplatesApi.baseApiUrl}`,
    put: `${CarePlanTemplatesApi.baseApiUrl}/:id`,
    setStatus: `${CarePlanTemplatesApi.baseApiUrl}/:id/status`,
    delete: `${CarePlanTemplatesApi.baseApiUrl}/:id`,
  };

  // No facilityId → full library (global + all clinics). Optional facilityId narrows to one clinic.
  public static async getAll(
    facilityId?: number | null,
  ): Promise<ICarePlanTemplate[]> {
    const path =
      facilityId != null && facilityId > 0
        ? `${this.apiUrls.getByFacility}?facilityId=${facilityId}`
        : this.apiUrls.getByFacility;
    return this.sendApiRequest<ICarePlanTemplate[]>({
      method: HttpMethodEnum.GET,
      path,
      data: undefined,
    });
  }

  public static async getForInvitation(
    facilityId: number,
    therapeuticIndicationId: number,
  ): Promise<ICarePlanTemplate[]> {
    const path = `${this.apiUrls.getForInvitation}?facilityId=${facilityId}&therapeuticIndicationId=${therapeuticIndicationId}`;
    return this.sendApiRequest<ICarePlanTemplate[]>({
      method: HttpMethodEnum.GET,
      path,
      data: undefined,
    });
  }

  public static async getById(id: number): Promise<ICarePlanTemplate> {
    return this.sendApiRequest<ICarePlanTemplate>({
      method: HttpMethodEnum.GET,
      path: this.apiUrls.getById,
      data: undefined,
      id: id.toString(),
    });
  }

  public static async post(
    data: ICarePlanTemplateInput,
  ): Promise<ICarePlanTemplate> {
    return this.sendApiRequest<ICarePlanTemplate>({
      method: HttpMethodEnum.POST,
      path: this.apiUrls.post,
      data,
    });
  }

  public static async put(
    id: number,
    data: ICarePlanTemplateInput,
  ): Promise<ICarePlanTemplate> {
    return this.sendApiRequest<ICarePlanTemplate>({
      method: HttpMethodEnum.PUT,
      path: this.apiUrls.put,
      data,
      id: id.toString(),
    });
  }

  public static async setStatus(
    id: number,
    status: CarePlanTemplateStatus,
  ): Promise<ICarePlanTemplate> {
    return this.sendApiRequest<ICarePlanTemplate>({
      method: HttpMethodEnum.PUT,
      path: this.apiUrls.setStatus,
      data: { status },
      id: id.toString(),
    });
  }

  public static async delete(id: number): Promise<void> {
    return this.sendApiRequest<void>({
      method: HttpMethodEnum.DELETE,
      path: this.apiUrls.delete,
      data: undefined,
      id: id.toString(),
    });
  }
}
